export const getPageFromUrl = (next: any) => {
  const newData = next?.split("?")[1];
  const urlParams = new URLSearchParams(newData);
  const { page } = Object.fromEntries(urlParams);

  return Number(page) || 1;
};
